<!--
 * @Author: zfd
 * @Date: 2020-08-21 17:24:24
 * @LastEditTime: 2020-08-29 09:35:21
 * @Description: 
 * @FilePath: \trip-manage\src\App.vue
-->
<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- sb3213213213 -->
      <router-view />
    </transition>
  </div>
</template>

<script>
import { getVoucher } from "@/common/auth";
function dateFormatHelper(value) {
  return value.toString().padStart(2, "0");
}
export default {
  name: "app",
  data() {
    return {};
  },
  provide() {
    return {
      voucher: getVoucher(),
      complementPicUrl: (id) => {
        return "/api/co/attachment/Download?code=" + id;
      },
      deepClone(obj) {
        if (obj === null) return null;
        if (typeof obj === "function") return new Function(obj);
        if (typeof obj !== "object") return obj;
        if (obj instanceof Date) return new Date(obj);
        if (obj instanceof RegExp) return new RegExp(obj);
        let result = new obj.constructor(),
          keys = Object.keys(obj);
        for (let key in obj) {
          if (keys.includes(key)) {
            result[key] = this.deepClone(obj[key]);
          }
        }
        return result;
      },
      dateFormat(value) {
        let date = new Date(value);
        if (value === null) {
          return "";
        }
        if (date.toString() === "Invalid Date") {
          return "";
        }
        return `${date.getFullYear()}-${dateFormatHelper(
          date.getMonth() + 1
        )}-${dateFormatHelper(date.getDate())} ${dateFormatHelper(
          date.getHours()
        )}:${dateFormatHelper(date.getMinutes())}:${dateFormatHelper(
          date.getSeconds()
        )}`;
      },
    };
  },
  created() {},
  methods: {},
  mounted() {},
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
}
</style>
